import React, {
    useCallback,
    useEffect,
    useState
} from "react";


import { useNavigate } from "react-router-dom";

const AdminUsers = () => {

    const navigate = useNavigate();

    const [users, setUsers] = useState([]);
    const [search, setSearch] = useState("");

    const [page, setPage] = useState(0);
    const [size] = useState(20);

    const [totalPages, setTotalPages] = useState(0);
    const [totalElements, setTotalElements] = useState(0);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");


    const loadUsers = useCallback(
        async (
            requestedPage = page,
            requestedSearch = search
        ) => {

            try {

                setLoading(true);
                setError("");

                const token =
                    localStorage.getItem("authToken");

                const params =
                    new URLSearchParams({
                        page: requestedPage,
                        size,
                        search: requestedSearch
                    });

                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}/api/admin/users?${params.toString()}`,
                    {
                        headers: {
                            Authorization:
                                token?.startsWith("Bearer ")
                                    ? token
                                    : `Bearer ${token}`
                        }
                    }
                );

                if (!response.ok) {
                    throw new Error(
                        "Unable to load users"
                    );
                }

                const data =
                    await response.json();

                setUsers(
                    data.content || []
                );

                setTotalPages(
                    data.totalPages || 0
                );

                setTotalElements(
                    data.totalElements || 0
                );

                setPage(
                    data.number || 0
                );

            } catch (error) {

                console.error(
                    "Admin users error:",
                    error
                );

                setError(
                    "Unable to load users."
                );

            } finally {

                setLoading(false);
            }
        },
        [
            page,
            search,
            size
        ]
    );


    useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const root = document.getElementById("root");

    const previousHtmlOverflow = html.style.overflow;
    const previousBodyOverflow = body.style.overflow;
    const previousBodyHeight = body.style.height;

    html.style.overflowY = "auto";
    html.style.overflowX = "hidden";

    body.style.overflowY = "auto";
    body.style.overflowX = "hidden";
    body.style.height = "auto";
    body.style.minHeight = "100vh";

    if (root) {
        root.style.overflow = "visible";
        root.style.height = "auto";
        root.style.minHeight = "100vh";
    }

    return () => {
        html.style.overflow = previousHtmlOverflow;
        body.style.overflow = previousBodyOverflow;
        body.style.height = previousBodyHeight;

        if (root) {
            root.style.overflow = "";
            root.style.height = "";
            root.style.minHeight = "";
        }
    };
}, []);




    useEffect(() => {
        loadUsers(0, "");
    }, [loadUsers]);



    useEffect(() => {
        const html = document.documentElement;
        const body = document.body;
        const root = document.getElementById("root");

        const previousHtmlOverflow = html.style.overflow;
        const previousBodyOverflow = body.style.overflow;
        const previousBodyHeight = body.style.height;

        html.style.overflowY = "auto";
        html.style.overflowX = "hidden";

        body.style.overflowY = "auto";
        body.style.overflowX = "hidden";
        body.style.height = "auto";
        body.style.minHeight = "100vh";

        if (root) {
            root.style.overflow = "visible";
            root.style.height = "auto";
            root.style.minHeight = "100vh";
        }

        return () => {
            html.style.overflow = previousHtmlOverflow;
            body.style.overflow = previousBodyOverflow;
            body.style.height = previousBodyHeight;

            if (root) {
                root.style.overflow = "";
                root.style.height = "";
                root.style.minHeight = "";
            }
        };
    }, []);


    const handleSearch = (e) => {

        e.preventDefault();

        setPage(0);

        loadUsers(
            0,
            search
        );
    };


    return (
        <div
            style={{
                width: "100%",
                minHeight: "100vh",
                height: "auto",
                overflow: "visible",
                background: "#f8f9fb",
                padding: "30px"
            }}
        >

            <div
                style={{
                    maxWidth: "1200px",
                    margin: "0 auto"
                }}
            >

                <button
                    type="button"
                    onClick={() =>
                        navigate("/admin")
                    }
                    style={{
                        marginBottom: "20px"
                    }}
                >
                    ← Dashboard
                </button>


                <h1>
                    Users Management
                </h1>

                <p>
                    {totalElements} users
                </p>


                <form
                    onSubmit={handleSearch}
                    style={{
                        display: "flex",
                        gap: "10px",
                        marginBottom: "25px"
                    }}
                >

                    <input
                        type="text"
                        value={search}
                        onChange={(e) =>
                            setSearch(
                                e.target.value
                            )
                        }
                        placeholder="Search name or email"
                        style={{
                            flex: 1,
                            padding: "12px",
                            borderRadius: "10px",
                            border:
                                "1px solid #ddd"
                        }}
                    />

                    <button
                        type="submit"
                        style={{
                            border: "none",
                            background: "#ff5f91",
                            color: "white",
                            padding:
                                "0 20px",
                            borderRadius: "10px",
                            cursor: "pointer"
                        }}
                    >
                        Search
                    </button>

                </form>


                {loading && (
                    <p>
                        Loading users...
                    </p>
                )}


                {error && (
                    <p
                        style={{
                            color: "red"
                        }}
                    >
                        {error}
                    </p>
                )}


                {!loading &&
                    users.map(
                        (user) => (

                            <div
                                key={user.id}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent:
                                        "space-between",
                                    gap: "15px",
                                    background: "#fff",
                                    padding: "15px",
                                    borderRadius: "14px",
                                    marginBottom: "12px"
                                }}
                            >

                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "14px"
                                    }}
                                >

                                    <img
                                        src={
                                            user.profilePicture ||
                                            "/default-avatar.png"
                                        }
                                        alt={user.name}
                                        style={{
                                            width: "55px",
                                            height: "55px",
                                            borderRadius: "50%",
                                            objectFit: "cover"
                                        }}
                                    />

                                    <div>

                                        <strong>
                                            {user.name}
                                        </strong>

                                        <div
                                            style={{
                                                fontSize: "13px",
                                                color: "#777"
                                            }}
                                        >
                                            {user.username}
                                        </div>

                                        <div
                                            style={{
                                                fontSize: "13px",
                                                color: "#999"
                                            }}
                                        >
                                            {user.city},{" "}
                                            {user.state}
                                        </div>

                                    </div>

                                </div>


                                <button
                                    type="button"
                                    onClick={() =>
                                        navigate(
                                            `/admin/users/${user.id}`
                                        )
                                    }
                                    style={{
                                        border: "none",
                                        background: "#ff5f91",
                                        color: "#fff",
                                        padding:
                                            "10px 16px",
                                        borderRadius: "9px",
                                        cursor: "pointer"
                                    }}
                                >
                                    View
                                </button>

                            </div>
                        )
                    )}


                <div
                    style={{
                        display: "flex",
                        justifyContent:
                            "space-between",
                        alignItems: "center",
                        marginTop: "25px"
                    }}
                >

                    <button
                        type="button"
                        disabled={
                            page === 0
                        }
                        onClick={() =>
                            loadUsers(
                                page - 1,
                                search
                            )
                        }
                    >
                        Previous
                    </button>


                    <span>
                        Page {page + 1}
                        {" of "}
                        {Math.max(
                            totalPages,
                            1
                        )}
                    </span>


                    <button
                        type="button"
                        disabled={
                            page + 1 >=
                            totalPages
                        }
                        onClick={() =>
                            loadUsers(
                                page + 1,
                                search
                            )
                        }
                    >
                        Next
                    </button>

                </div>

            </div>

        </div>
    );
};


export default AdminUsers;